// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_64-6";
export var headerCell = "_64-2";
export var rowWrapper = "_64-4";
export var stickyAggregationCell = "_64-a";
export var stickyAggregationRow = "_64-7";
export var stickyColumnCell = "_64-9";
export var stickyColumnHeaderCell = "_64-8";
export var table = "_64-1";
export var virtualRowWrapper = "_64-5";
export var virtualTableContainer = "_64-0";
export var white = "_64-3";